export const canCaptureLead = (lead, user, older = null) => {
  // lead suspensa, nao renderiza
  if (lead?.suspended_lead) return false;
  // lead state diferente de 1, nao renderiza
  if (lead.state != 1) return false;

  // lead em atendimento pela IA
  if (lead?.status == 8) return false;

  // user role menor ou igual a 2, renderiza
  if (user.role <= 2) return true;

  // se tiver broker_id e broker_id != user id, nao  renderiza
  if (lead.broker_id && lead.broker_id != user.id) return false;

  // "Esquentado IA" (9) e "Desinteressado IA" (10) nao seguem a fila do older
  if ([9, 10].includes(Number(lead.status))) return true;

  // se nao tiver dentro do array e lead id diferente de older e lead broker id for nulo, nao renderiza
  if (![7, 8, 9, 10, 14, 27, 28, 29].includes(lead.channel_id) && lead.id != older && lead.broker_id == null) {
    if (older == null && lead.broker_id == null) return true;

    if (lead?.id != older && lead?.broker_id == null) return false;
  }

  return true;
};

// status "Esquentado IA" (9) e "Desinteressado IA" (10): captura exige usuario vinculado ao ChatGuru
const CHATGURU_REQUIRED_STATUS = [9, 10];

export const isMissingChatguruToCapture = (lead, user) =>
  CHATGURU_REQUIRED_STATUS.includes(Number(lead?.status)) && !user?.chatguru_user_id;

// leads do canal 1 aguardando captura: sem ID ChatGuru o lead nao e integrado direto ao ChatGuru
export const shouldWarnMissingChatguru = (lead, user) =>
  Number(lead?.channel_id) === 1 && Number(lead?.state) === 1 && !user?.chatguru_user_id;
